<template>
  <c-view>
    <c-page>
      <c-content>
        <div class="content">
          <div class="logo"></div>
          <div class="container">
            <div class="title">注册生意专家</div>
            <div class="desc">{{ desc }}</div>
            <div class="input-groups">
              <div class="input-group">
                <i class="icon phone-icon"></i>
                <input type="tel" placeholder="输入手机号码作为登录账号" v-model="phone">
              </div>
              <div class="input-group">
                <i class="icon password-icon"></i>
                <input type="password" placeholder="设置登录密码" v-model="pass">
              </div>
              <div class="input-group">
                <i class="icon password-icon"></i>
                <input type="tel" placeholder="输入验证码" v-model="code">
                <button class="code-btn" :disabled="codeWorking" @click="sendCode">{{ codeText }}</button>
              </div>
            </div>
            <c-button class="weui-overwrite-btn" @click.native="submitSignupProcess">立即注册</c-button>
          </div>
          <div class="footer-container">
            <info-footer></info-footer>
          </div>
        </div>
      </c-content>
    </c-page>
  </c-view>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  import axios from 'axios'
  import qs from 'qs'
  import InfoFooter from '../info-footer'

  export default {
    data () {
      return {
        desc: '',
        phone: '',
        pass: '',
        code: '',
        codeTimeout: 60,
        timer: null,
        codeWorking: false,
        codeTextDefault: '获取',
        signuping: false,
        codeText: '',
        url: 'http://register.fe.yuanbei.biz/ApiProxy/api/wechat.ashx' // nginx => http://app.i200.cn/api/wechat.ashx
//        url: 'http://192.168.20.195:8080/api/wechat.ashx'
      }
    },
    components: {InfoFooter},
    created () {
      this.codeText = this.codeTextDefault
      this.desc = this.$route.query.desc
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {
      urlMaker (data) {
        let query = qs.stringify(data)
        return `${this.url}?${query}`
      },
      sendCode () {
        if (this.codeWorking) return
        if (!this.verifyPhone()) {
          this.$wejs.topTips('请输入正确的手机号')
          return
        }
        if (!this.verifyPassword()) {
          this.$wejs.topTips('请输入6位以上的密码')
          return
        }
        this.signupProcess()
      },
      fireTimer () {
        if (this.timer) clearTimeout(this.timer)
        this.codeWorking = true
        let now = 0
        let timerProc = () => {
          now += 1
          if (now < this.codeTimeout) {
            this.codeText = `${this.codeTimeout - now} s`
            this.timer = setTimeout(timerProc, 1000)
          } else {
            this.codeText = this.codeTextDefault
            this.codeWorking = false
          }
        }
        timerProc()
        return new Promise(resolve => {
          resolve()
        })
      },
      signupProcess () {
        // 18955063064
        this.haveSignup()
          .then(() => {
            return this.getVerifyCode()
          })
          .then(() => {
            return this.fireTimer()
          })
      },
      getVerifyCode () {
        let url = this.urlMaker({
          type: 'sendvertifycode',
          phone: this.phone
        })
        return new Promise(resolve => {
          axios.get(url).then(res => {
            let data = res.data
            if (data === 0) {
              this.$wejs.toast('验证码已发送')
              resolve()
            }
          }).catch(e => {
            this.$wejs.topTips('抱歉发送出错')
          })
        })
      },
      haveSignup () {
        let url = this.urlMaker({
          type: 'checkphone',
          phone: this.phone
        })
        return new Promise((resolve) => {
          axios.get(url).then(res => {
            let data = res.data
            if (data && data.length > 0) {
              this.$wejs.topTips('此号码已注册')
            } else {
              resolve()
            }
          }).catch(e => {
          })
        })
      },
      submitSignupProcess () {
        if (!this.verifyPhone()) {
          this.$wejs.topTips('请输入正确的手机号')
          return
        }
        if (!this.verifyPassword()) {
          this.$wejs.topTips('请输入6位以上的密码')
          return
        }
        if (!this.verifyCode()) {
          this.$wejs.topTips('请输入验证码')
          return
        }
        if (this.signuping) return
        this.checkVertifyCode()
          .then(() => {
            this.submitSignup()
          })
      },
      checkVertifyCode () {
        let url = this.urlMaker({
          type: 'checkvertifycode',
          phone: this.phone,
          code: this.code
        })
        return new Promise(resolve => {
          axios.get(url).then(res => {
            let data = res.data
            if (data === 0) {
              resolve()
            } else if (data === -2) {
              this.$wejs.topTips('验证码不正确,请重新发送')
            }
          }).catch(e => {
          })
        })
      },
      submitSignup () {
        let url = this.urlMaker({
          type: 'submitreginfo',
          phone: this.phone,
          pwd: this.pass,
          code: this.code
        })
        this.signuping = true
        let handler = this.$wejs.loading('注册中')
        axios.get(url).then(res => {
          this.signuping = false
          handler.hide()
          let data = res.data
          if (data === 0) {
            this.$wejs.toast('注册成功')
            this.$router.replace({name: 'SignupStatus'})
          }
        }).catch(e => {
          handler.hide()
          this.signuping = false
        })
      },
      verifyPhone () {
        return this.phone && this.phone.length === 11 && /^1[34578]\d{9}$/.test(this.phone)
      },
      verifyPassword () {
        return this.pass && this.pass.length >= 6
      },
      verifyCode () {
        return this.code && this.code.length >= 4
      }
    },
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?ed04cf1e